import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '@/hooks/useApiMutation';
import { apiPut, operationsClient } from '@/lib/api/client';
import { taxCodeEndpoints } from '@/lib/api/endpoints';
import { taxZoneKeys, taxGroupKeys } from '@/lib/queryKeys';

export function useUpdateTaxCodeRate() {
  const qc = useQueryClient();
  return useApiMutation<void, { id: string; rateOverride: number }>({
    mutationFn: ({ id, rateOverride }) =>
      apiPut<void>(operationsClient, taxCodeEndpoints.update(id), { rateOverride }),
    onSuccess: () => {
      toast.success('Tax rate override saved.');
      void qc.invalidateQueries({ queryKey: taxZoneKeys.all() });
      void qc.invalidateQueries({ queryKey: taxGroupKeys.all() });
    },
  });
}
